import React, { FC, useState } from 'react'
import AEAStep from './aea-step/aea-step';
import { String, Utilities } from '@utils';
import styles from './aea-stepper.module.scss';

export interface AEAStepperProps{
    children: any;
    defaultStep: string;
    errorSelectors?: Array<string>;
    activateValidation?:boolean;
    activeAll?:boolean;
}

const AEAStepper: FC<AEAStepperProps> = (props: AEAStepperProps) => {    
    const [currentStep, setCurrentStep] = useState(`step-${props.defaultStep}`)
    
    const onValidationFuncion = (container: HTMLElement) => {
        if(props.activateValidation){
            if(!Utilities.isNullObject(container)){
                let errors:NodeList = null;
                for(var i = 0; i < props.errorSelectors.length; i++){
                    const selector = props.errorSelectors[i];
                    errors = container.querySelectorAll(selector);
                    if(errors.length > 0){
                        return false;
                    }
                }
            }
            return true;
        }
        return null;
    }

    const onChangeStep = (keyStep: string) => {
        if(keyStep === currentStep){
            setCurrentStep(String.Empty)
        } else {
            setCurrentStep(keyStep);
        }
    }
    
    return (
        <div className={styles.Stepper}>
          {props.children?.map((child: any, i:number) => {
              if(!Utilities.isNullEmptyObject(child.props?.title)){
                const newKey = `step-${child.props.title}`;
                return (<AEAStep 
                    {...child.props} 
                    id={newKey}
                    key={newKey}
                    index={i + 1}
                    active={props.activeAll ? true : currentStep === newKey} 
                    onChangeStep={onChangeStep}
                    onValidationFuncion={onValidationFuncion}/>);
              }
            })}
        </div>
    )
    
}

export default AEAStepper;
